export const PLUGIN_NAME = 'auth-local-fe';
export const PROVIDER_KEY = 'blaze_auth_local';
export const PROVIDER_NAME = 'Blaze auth local';
export const GRAPH_QL_ERROR = 'GraphQL error: ';
export const PASSWORD_REGEX = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,}$/;
export const EMAIL = 'email';
export const PASSWORD = 'password';
export const LOGIN_FORM = 'loginForm';
export const TRANSLATION_NAMESPACE = PLUGIN_NAME;
//# sourceMappingURL=constants.js.map